import {
    addBlockOut,
    moveBlockOut,
    removeBlockOut,
    resizeBlockOut,
    addCircularBlockOut,
    moveCircularBlockOut,
    removeCircularBlockOut,
    resizeCircularBlockOut
} from "../../features/intermediateCeiling/intermediateCeilingSlice";
import {
    addCircularElement, circularElementResizeBoundFunc,
    moveCircularElement,
    previewAddCircularElement,
    previewMoveCircularElement, previewResizeCircularElement, resizeCircularElement
} from "./circularElementDomainFunctions";
import {
    createLidAndIntermediateCeilingBlockOutDomainFunctions
} from "./lidAndIntermediateCeilingBlockOutDomainFunctions";

export const createIntermediateCeilingDomainFunctions = (dispatch, plan) => {
    return {
        blockOutFunctions: createLidAndIntermediateCeilingBlockOutDomainFunctions(
            dispatch,
            plan,
            {addBlockOut, moveBlockOut, removeBlockOut, resizeBlockOut}
        ),
        circularBlockOutFunctions: {
            previewAdd: item => previewAddCircularElement(plan.length, plan.width, item),
            add: item => addCircularElement(
                item => dispatch(addCircularBlockOut({blockOut: item})),
                plan.length,
                plan.width,
                item
            ),
            previewMove: item => previewMoveCircularElement(plan.length, plan.width, item),
            move: item => moveCircularElement(
                (id, x, y) => dispatch(moveCircularBlockOut({id, x, y})),
                plan.length,
                plan.width,
                item
            ),
            remove: id => dispatch(removeCircularBlockOut({id})),
            previewResize: (item) => previewResizeCircularElement(plan.length, plan.width, item),
            resize: item => resizeCircularElement(
                (id, diameter) => dispatch(resizeCircularBlockOut({id, diameter})),
                plan.length,
                plan.width,
                item
            ),
            resizeBoundFunc: (blockOut, pos) => circularElementResizeBoundFunc(pos, plan.length, plan.width, blockOut)
        }
    }
}
